export default "__VITE_ASSET__DMhDNnFj__"